import { Grid } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { AutoComplete } from "@4uhub/lib4uhub";

import { listMainGenerics } from "../../../../services/generic.service";

const translationPath = "page.assessments.questions.";

export const QuestionGuidanceTextPosition = memo(() => {
  const { t } = useTranslation();

  return (
    <Grid item xs={12} sm={12}>
      <AutoComplete
        getOptionLabel={({ name }) => name}
        size="small"
        fullWidth
        label={t(translationPath + "guidance_text_position")}
        name="guidanceTextPosition"
        request={listMainGenerics}
        params={{ Identifier: "QuestionGuidanceTextPosition" }}
      />
    </Grid>
  );
});
